import { render, staticRenderFns } from "./BeaconSetting.vue?vue&type=template&id=0c68dbf5&scoped=true&"
import script from "./BeaconSetting.vue?vue&type=script&lang=js&"
export * from "./BeaconSetting.vue?vue&type=script&lang=js&"
import style0 from "./BeaconSetting.vue?vue&type=style&index=0&id=0c68dbf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c68dbf5",
  null
  
)

export default component.exports